import { render, staticRenderFns } from "./SolicitudesRevisadasLista.html?vue&type=template&id=7c8c72fc&external"
import script from "./SolicitudesRevisadasLista.vue?vue&type=script&lang=js"
export * from "./SolicitudesRevisadasLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports